<script>
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {Link} from "@inertiajs/vue3";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";

export default {
    name: "ComingSoonPage",
    components: {Breadcrumbs, Link, MobileTopBar}
}
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs/>
    </div>
    <div class="container flex flex-col md:items-center md:justify-center md:text-center mt-5 md:mt-10">
        <h1 class="text-4xl md:text-5xl font-semibold mb-2 text-gray-800">
            В разработке
        </h1>
        <p class="text-lg text-gray-600 mb-6">
            Мы готовим что-то интересное. Заходите чуть позже!
        </p>
        <Link :href="route('home')"
              class="inline-block px-6 py-3 text-center bg-baseColor text-white rounded-lg md:hover:bg-baseColor/90 transition">
            На главную
        </Link>
    </div>
</template>

<style scoped lang="scss">

</style>
